import { NgFor, NgIf } from '@angular/common'
import { Component } from '@angular/core'
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatNativeDateModule } from '@angular/material/core'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatDialogRef } from '@angular/material/dialog'
import {
    MatError,
    MatFormField,
    MatFormFieldModule,
    MatLabel,
} from '@angular/material/form-field'
import { MatIcon, MatIconModule } from '@angular/material/icon'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { MatStepperModule } from '@angular/material/stepper'
import { ToastrService } from 'ngx-toastr'
import { SocioeconomicstatusService } from '../../services/socioeconomicstatus/socioeconomicstatus.service'
import {
    SocioEconomicStatus,
    SocioEconomicStatusDTO,
} from '../../models/socioeconomicstatus.interface'
import {
    civilStatus,
    disabilityTypes,
    ethnic,
    religion,
    sexualOrientation,
} from '../incident-observatorio/incident-form/incident.definitions'
import { Location } from '../../models/location.interface'
import { SearchSelectComponent } from '../../components/search-select/search-select.component'
import { LocationService } from '../../services/location/location.service'

@Component({
    selector: 'app-socioeconomicstatus-form',
    standalone: true,
    imports: [
        MatStepperModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatError,
        MatIcon,
        MatIconModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgIf,
        NgFor,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        SearchSelectComponent,
    ],
    templateUrl: './socioeconomicstatus-form.component.html',
    styleUrl: './socioeconomicstatus-form.component.css',
})
export class SocioeconomicstatusFormComponent {
    selectedSocioEconomic: SocioEconomicStatus | null = null
    socioEconomicId: string | null = null
    errorMsg: string[] | null = null
    civilStatus = civilStatus
    sexualOrientation = sexualOrientation
    ethnic = ethnic
    disabilityTypes = disabilityTypes
    religion = religion
    locations: Location[] = []
    displayFn = (location: Location) => location?.city ?? ''
    idFn = (location: Location) => location.id

    constructor(
        private dialogRef: MatDialogRef<SocioeconomicstatusFormComponent>,
        private fb: FormBuilder,
        private toastr: ToastrService,
        private locationService: LocationService,
        private socioeconomicService: SocioeconomicstatusService
    ) {}

    ngOnInit(): void {
        this.locationService.allLocation().subscribe((data) => {
            this.locations = data
            this.socioeconomicService.$socioEconomicsSelected.subscribe(
                (socioEconomic) => {
                    if (socioEconomic) {
                        this.socioEconomicId = String(socioEconomic.id)
                        this.selectedSocioEconomic = socioEconomic
                        this.editsocioEconomicForm.patchValue({
                            ...socioEconomic,
                            placeWork: socioEconomic.placeWork ?? null,
                            disability:
                                this.socioeconomicService.parseDisability(
                                    socioEconomic.disability as unknown
                                ),
                        })
                    }
                }
            )
        })
    }

    editsocioEconomicForm = this.fb.group({
        isHeadOfHousehold: [false],
        qtyChildren: [0, []],
        religion: ['', []],
        ownsLand: [false],
        landArea: [0, []],
        isConflictVictim: [false],
        hasProtectionScheme: [false],
        civilianStatus: ['', []],
        gender: ['', []],
        culturaEthnic: ['', []],
        sourceIncome: ['', []],
        sourceIncomeMethod: ['', []],
        disability: this.fb.control<string[]>([]),
        isLandOwner: [false],
        placeWork: this.fb.control<Location | null>(null),
    })

    closeDialog() {
        this.dialogRef.close()
    }

    updatesocioEconomic() {
        if (
            this.editsocioEconomicForm.status !== 'VALID' ||
            !this.socioEconomicId
        )
            return
        if (this.editsocioEconomicForm.pristine) {
            this.dialogRef.close()
            return
        }

        const raw = this.editsocioEconomicForm.getRawValue()

        const { placeWork, ...rest } = raw as {
            placeWork: Location | number | null
        } & Record<string, unknown>

        const placeWorkId =
            typeof placeWork === 'number' ? placeWork : placeWork?.id ?? null

        const id = Number(this.socioEconomicId)

        const payload: SocioEconomicStatusDTO & { id: number } = {
            ...(rest as Omit<SocioEconomicStatusDTO, 'placeWork'>),
            id,
            placeWork: placeWorkId,
            disability: this.socioeconomicService.formatDisability(
                raw.disability as unknown
            ),
        }

        this.socioeconomicService.updateSocioEconomic(id, payload).subscribe({
            next: () => {
                this.toastr.success(
                    'El registro fue EDITADO correctamente!',
                    'Exitoso!',
                    {
                        progressBar: true,
                        timeOut: 5000,
                    }
                )
                this.dialogRef.close()
            },
            error: () => {
                if (this.errorMsg) {
                    this.toastr.error('Error: ' + this.errorMsg, undefined, {
                        progressBar: true,
                        timeOut: 5000,
                    })
                }
            },
        })
    }
}
